import { render, staticRenderFns } from "./usinessPartner.vue?vue&type=template&id=850b3578&scoped=true"
import script from "./usinessPartner.vue?vue&type=script&lang=js"
export * from "./usinessPartner.vue?vue&type=script&lang=js"
import style0 from "./usinessPartner.vue?vue&type=style&index=0&id=850b3578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850b3578",
  null
  
)

export default component.exports